import { render, staticRenderFns } from "./SalesMade.vue?vue&type=template&id=394f53a8&"
import script from "./SalesMade.vue?vue&type=script&lang=js&"
export * from "./SalesMade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports